import axios from './financeiroApi';

const grupoClienteApi = () => {
  const getPathGrupoCliente = () => {
    return `/api/v1/backend/grupo-cliente`;
  };

  const getParams = (params) => {
    let newParams;
    if (params?.filtroAvancado) {
      if (params.filtroAvancado.identificador) {
        newParams = {
          ...params,
          ...params.filtroAvancado,
          identificador: parseInt(params.filtroAvancado.identificador),
        };
      } else {
        newParams = { ...params, ...params.filtroAvancado };
      }

      delete newParams.filtroAvancado;
    } else {
      newParams = params;
    }

    newParams = {
      ...newParams,
      data: newParams?.data?.format('YYYY-MM-DD'),
    };

    return newParams;
  };

  return {
    criarGrupoCliente: async (grupoCliente) => {
      const url = `${getPathGrupoCliente()}`;
      return axios.post(url, grupoCliente);
    },
    atualizarGrupoCliente: async (grupoCliente) => {
      const url = `${getPathGrupoCliente()}/${grupoCliente.id}`;
      return axios.put(url, grupoCliente);
    },
    removerGrupoCliente: async (grupoClienteId) => {
      const url = `${getPathGrupoCliente()}`;
      return axios.delete(`${url}/${grupoClienteId}`);
    },
    buscarGrupoCliente: async (search) => {
      const url = `${getPathGrupoCliente()}`;
      return axios.get(url, { params: getParams(search) });
    },
    buscarGrupoClientePorId: async (grupoClienteId) => {
      const url = `${getPathGrupoCliente()}`;
      return axios.get(`${url}/${grupoClienteId}`);
    },
  };
};

export { grupoClienteApi };
